<script lang="ts">
import { defineComponent } from 'vue';
import { string } from 'vue-types';

// import TitleBreadcrumbs from '@/ui/Breadcrumbs/TitleBreadcrumbs.vue';
import Section from './Section.vue';

import Breadcrumbs from '@/ui/Breadcrumbs/Breadcrumbs.vue';
import Copy from '@/ui/Copy.vue';
import HeadTitle from '@/ui/HeadTitle.vue';

export default defineComponent({
  name: 'Page',
  components: {
    Section,
    Copy,
    HeadTitle,
    Breadcrumbs,
  },
  props: {
    title: string(),
    titleBreadcrumbs: string(),
    noBg: Boolean,
  },
});
</script>

<template>
  <HeadTitle :title="titleBreadcrumbs ?? title" />
  <div id="wrapper" class="flex min-w-0 flex-1">
    <div
      id="main"
      :class="[
        'flex',
        'min-w-0',
        'flex-col',
        'h-full',
        'relative',
        'grow',
        'min-w-0',
      ]"
    >
      <div class="bg-white dark:bg-gray-900 px-5 pt-3">
        <Breadcrumbs class="mb-1.5" />
        <slot name="title">
          <div class="flex justify-between">
            <h1 class="mb-4 text-2xl">
              <slot name="title-text">
                {{ title }}
              </slot>
            </h1>
            <slot name="header" />
          </div>
        </slot>
      </div>
      <div class="px-5 pt-5 bg-gray-100 dark:bg-black flex min-w-0 grow flex-col">
        <div class="grid min-w-0 flex-1">
          <slot v-if="noBg" name="content" />
          <Section v-else>
            <slot name="content" />
          </Section>
        </div>
        <Copy class="bg-gray-100 dark:bg-black" />
      </div>
    </div>
    <slot name="sidebar" />
  </div>
</template>
